"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const item_1 = require("./item");
require("./list.css");
/** The element encloses a list of groups of terms and descriptions. */
const List = ({ hasSeparator = true, children, className, dataTest = 'list', spacing = 'medium', reverseSize = false, hasBottomSeparator = true, hasTopSeparator = true, ...other }) => {
    const classes = (0, classnames_1.default)('dsc-list', !hasSeparator && 'has-noSeparator', hasSeparator && !hasBottomSeparator && 'has-noBottomSeparator', hasSeparator && !hasTopSeparator && 'has-noTopSeparator', spacing !== 'medium' && `has-spacing-${spacing}`, reverseSize && `has-reverseSize`, className);
    return ((0, jsx_runtime_1.jsx)("div", { className: "dsc-list-container", children: (0, jsx_runtime_1.jsx)("dl", { ...other, className: classes, "data-test": dataTest, children: children }) }));
};
exports.List = List;
exports.List.Item = item_1.Item;
exports.List.displayName = 'List';
exports.default = exports.List;
//# sourceMappingURL=list.js.map